import FriendsDemo from './demo/FriendsDemo';
import WeightDemo from './demo/WeightDemo';
import SleepDemo from './demo/SleepDemo';
import JournalDemo from './demo/journal/JournalDemo';
import mockJournalData from './demo/journal/mockJournalData';

export const SITE_NAME = process.env.REACT_APP_SITE_NAME || 'NutriPulse';
const JournalPreview = () => <JournalDemo demoData={mockJournalData} />;

export const LANDING_SECTIONS = [
  {
    id: 'journal',
    title: 'Journal alimentaire',
    reverse: false,
    component: JournalPreview,
  },
  {
    id: 'friends',
    title: 'Amis',
    reverse: false,
    component: FriendsDemo,
  },
  {
    id: 'weight',
    title: 'Suivi du poids',
    reverse: true,
    component: WeightDemo,
  },
  {
    id: 'sleep',
    title: 'Suivi du sommeil',
    reverse: true,
    component: SleepDemo,
  }
];

export const HERO_HIGHLIGHTS = [
  'Une vue d\'ensemble simple de vos repas',
  'Des repères clairs pour vos objectifs',
  'Un suivi qui vous motive au quotidien',
];

export const HERO_TRUST_STATS = [
  { value: '4.8/5', label: 'Note utilisateurs' },
  { value: '50k+', label: 'Aliments référencés' },
  { value: '100%', label: 'Données sécurisées' },
];

export const BENEFITS_CARDS = [
  {
    id: 'daily',
    kicker: 'Au quotidien',
    title: 'Un flux simple et lisible',
    outline: false,
    items: [
      'Saisie rapide des repas avec aperçu nutritionnel immédiat.',
      'Suivi sommeil avec sessions détaillées et tendances par période.',
      'Suivi poids avec progression claire vers votre objectif.',
    ],
  },
  {
    id: 'friends',
    kicker: 'Avec vos amis',
    title: 'Partage maîtrisé, sans confusion',
    outline: true,
    items: [
      'Visibilité configurable indépendamment pour journal, sommeil et poids.',
      'Actions adaptées selon les droits, sans boutons inutiles.',
      'Gestion directe des contacts depuis une interface homogène.',
    ],
  },
];

export const INTERSECTION_OBSERVER_CONFIG = {
  threshold: 0.2,
  rootMargin: '0px 0px -8% 0px',
};
